<template>
  <div class="fixed bottom-0 left-0 right-0 py-4 text-center text-gray-400 text-sm bg-gradient-to-b from-gray-900 to-gray-800 z-40">
    {{ $t('contact.copyright') }}
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>
